export const createInviteCodeSuccess = 'Successfully created invite code!';
export const createInviteCodeEmptySet = ' has no invite codes yet';
export const addInvite = 'add';
